import { FC } from "react";
import { IconPropsType } from ".";

export const AngleDown: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 4.25313L1.50188 0.666565L-2.69262e-07 2.20656L5 7.33313L10 2.20656L8.49813 0.666566L5 4.25313Z"
        fill={props.color}
      />
    </svg>
  );
};
